import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { SessionDialogComponent } from 'src/app/components/session/session-dialog/session-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GlobalService } from '../helper/global-helper';
import { TranslateService } from '@ngx-translate/core';
import { DidDataRetrievalService } from '../apiHandler/did-data-retrieval/did-data-retrieval.service';
import { DidConfigService } from '../apiHandler/did-config/did-config.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GatewayConnectionService } from '../apiHandler/gateway-connection/gateway-connection.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private occurred = false;
  private connected = false;
  snackbar = inject(MatSnackBar);

  constructor(private dialog: MatDialog, private keycloak: KeycloakService, private router: Router, private global: GlobalService, private translate: TranslateService,private configService: DidConfigService, private retrievalService: DidDataRetrievalService, private gwService: GatewayConnectionService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.global.error.subscribe({
      next: newValue => {this.occurred = newValue.occurred;}
    });
    this.global.variables.subscribe({
      next: newValue => {this.connected = newValue.connected;}
    });
    return next.handle(request).pipe(
      catchError((error: any) => {
        if(error instanceof HttpErrorResponse){
          // Handle HTTP errors
          if (error.status === 0) {
            if(error.url!.includes('sentrack.sennebogen')) {
              console.error("Sentrack Error", error);
              let code = 'ERROR.SENTRACK';
              this.global.variables.next({attempt: false, error: true, message: code});
            }
            if(!this.gwService.backendAlive) {
              if(this.connected) {
                if(!this.occurred) {
                  console.error("Backend unreachable", error);
                  sessionStorage.clear();
                  this.global.cancelPendingRequests();
                  this.retrievalService.stopSendQueryAliveState();
                  this.global.machineNumber.next({ number: '', id: '', series: ''});
                  this.global.machineInfos.next({line: '', name: '', engine: ''});
                  this.global.variables.next({connected: false, attempt: false});
                  this.global.comission.next({enabled: false});
                  this.global.error.next({occurred: true});
                  this.dialog.open(SessionDialogComponent, {data: {code: '0'}});
                }
              } else {
                if(!this.occurred){
                  this.global.error.next({occurred: true});
                  this.snackbar.open(this.translate.instant('ERROR.BACKEND'), undefined, {verticalPosition: 'top', panelClass: 'error-snackbar'});
                }
              }
            }            
          } else if(error.status === 423) {
            console.error("Session attempt was denied!", error);
            this.global.variables.next({attempt: false});
            this.dialog.closeAll();
            this.dialog.open(SessionDialogComponent, {data: {code: '423', request: request, error: error.error}});

          } else if(error.status === 428){
            /* User has been kicked out of his session or the machine did not respond anymore(?)
             - Proceed to take to machine selection page */
            if(!this.occurred) {
              console.error("You have been kicked out!", error);
              this.global.cancelPendingRequests();
              this.retrievalService.stopSendQueryAliveState();
              this.global.machineNumber.next({ number: '', id: '', series: ''});
              this.global.machineInfos.next({line: '', name: '', engine: ''});
              this.global.variables.next({ connected: false, attempt: false});
              this.global.comission.next({enabled: false});
              this.global.error.next({occurred: true});
              this.router.navigateByUrl("");
              this.dialog.open(SessionDialogComponent, {data: {code: '428'}});
            } else {
              console.log("error already occured");
            }

          } else if(error.status === 400) {
            if(error.error['type']?.includes('SW-VERSION')) {
              console.error("SW-Version Error", error);
              return of(new HttpResponse({
                status: 400,
              }));
            }
            if(error.url!.includes('sentrack.sennebogen')) {
              console.error("Sentrack Error", error);
            }

          } else if(error.status === 401) {
            if(error.url!.includes('/api/v2/')) {
              console.error("Unauthorized", error);
              this.snackbar.open(this.translate.instant('ERROR.UNAUTH'), undefined, {verticalPosition: 'top', panelClass: 'error-snackbar'});
              let code = 'ERROR.UNAUTH';
              this.global.variables.next({attempt: false, error: true, message: code});
            } else {
              console.error("Unauthorized", error);
              this.router.navigate(['/']);
              // gateway disconnecten - Problem: Man darf keine Aufrufe machen
              this.keycloak.logout();
            }

          } else if(error.status === 403) {
            if(error.error['type']?.includes('SW-VERSION')) {
              console.error("SW-Version Error", error);
              return of(new HttpResponse({
                status: 403,
              }));
            }

          } else if(error.status === 404) {
            if(error.error['Error']?.includes('DID')) {
              console.error("DID Mapping not found!", error);
              this.global.variables.next({attempt: false,  error: true, message: 'ERROR.DID_MAP'});
              this.global.setErrorMessage('ERROR.DID_MAP');
            }
            if(error.error['type']?.includes('SW-VERSION')) {
              console.error("SW-Version Error", error);
              if(error.error['error']?.includes('unique')) {
                return of(new HttpResponse({
                  status: 404,
                  body: 'machine'
                }));
              } else if(error.error['error']?.includes('software')){
                return of(new HttpResponse({
                  status: 404,
                  body: 'software'
                }));
              }
            }
            if(error.error['errorName']?.includes('GUIDE_NOT_FOUND')) {
              console.error("Troubleshooterguide not found!", error);
              return of(new HttpResponse({
                  status: 404
              }));
            }

          } else if(error.status === 504) {
            console.error("No connection to gateway!", error);
            return of(new HttpResponse({
              body: '504 ' + error.error
            }));

          } else if(error.status === 500) {
            if(error.error['type']?.includes('SW-VERSION')) {
              console.error("SW-Version Error", error);
              return of(new HttpResponse({
                status: 500,
              }));
            } else if(error.url!.includes('sentrack.sennebogen')){
              console.error("Sentrack Error", error);
              this.snackbar.open(this.translate.instant('ERROR.SENTRACK'), undefined, {verticalPosition: 'top', panelClass: 'error-snackbar'});
              let code = 'ERROR.SENTRACK';
              this.global.variables.next({attempt: false, error: true, message: code});
            } else if(window.location.href.includes('connection')) {
              console.error("No connection to gateway!", error);
              let code = 'ERROR.INTERNAL_ERROR';
              this.global.variables.next({attempt: false, error: true, message: code});
            } else if (window.location.href ==  window.location.origin + '/') {
              console.error("No connection to gateway!", error);
              let code = this.handle500Error(error);
              this.global.variables.next({attempt: false, error: true, message: code});
              this.global.setErrorMessage(code);
            } else {
              console.error("No connection to gateway!", error);
              let code = this.handle500Error(error);
              this.global.variables.next({attempt: false, error: true, message: code});
              this.global.setErrorMessage(code);
              this.dialog.closeAll();
            }

          } else {
            console.error("HTTP error: ", error);
          }
        } else {
          console.error("an error occured: ", error);
        }
        // Re-throw the error to propagate it further
        return throwError(() => error);
      })
    );
  }

  private handle500Error(error: HttpErrorResponse) {
    let code = 'ERROR.INTERNAL_ERROR';
    let err = error.error['Error'];
    if(err?.includes('DOIP')) {
      code = 'ERROR.DOIP_CON';
    } else if(err?.includes('bridge')) {
      code = 'ERROR.BRIDGE';
    }
    return code;
  }
}